/**
 * AJAX add-to-cart for 361 Sleep hero/footer CTAs.
 * Forms with class `js-361-add-to-cart` add the product and open the cart drawer.
 */
(function () {
  function getCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('js-361-add-to-cart')) return;

    event.preventDefault();

    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

    var cart = getCart();
    var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
    };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }
    config.body = formData;

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error(response.description || response.message || 'Cart add failed');
          return;
        }

        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        if (typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }

        if (cart.classList && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: '361-add-to-cart',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
      });
  }

  document.addEventListener('submit', onSubmit, true);
})();
